import { Typography } from '@polyseme/design-system';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import React from 'react';

import { images } from '~/landing/assets';

import { footerLinks } from './sections';

export const GermenFooter = () => {
  const t = useTranslations('landing.common.footer');

  return (
    <footer className="mx-auto flex w-full max-w-screen-xl flex-col items-center justify-between gap-4 px-4 py-10 md:flex-row">
      <Image
        alt="Germen"
        height={42}
        src={images.polyseme.germen}
        width={200}
      />
      <nav>
        <ul className="flex gap-4">
          {footerLinks.map((link) => (
            <li key={link.href}>
              <Typography asChild>
                <a
                  className="hover:underline"
                  href={link.href}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t(`links.${link.key}`)}
                </a>
              </Typography>
            </li>
          ))}
        </ul>
      </nav>
    </footer>
  );
};
